var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"skip-links link-button-primary visually-hidden-focusable",attrs:{"href":"#main"}},[_vm._v(" "+_vm._s(_vm.$translations.getTranslation('aria_label_skip_links_text' , 'Skip to main content'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }